import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import React from 'react';
import TOOLBAR_FONT_SETTING from '@tencent/docs-design-resources/pc/svg/toolbar_font_setting.svg';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

export const config = {
    id: ActionType.FONT_HANDLER,
    content: i18n.t('字体处理'),
};

export const toolbarConfig = {
    id: ActionType.UNIFORM_FONT_TOOLBAR,
    content: i18n.t('统一字体'),
    twdConfig: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.BEAUTIFY_TAB,
        action: TDWActionType.BEAUTIFY_UNIFY_FONT,
        ver3: 1,
    },
};


export const INSERT_TEXT_MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        tooltip: config.content,
        style: {
            cursor: 'default',
            background: 'transparent',
        },
        preventDismiss: true,
        preventHighlight: true,
    },
    {
        name: toolbarConfig.id,
        content: '',
    },
];

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: toolbarConfig.id,
        style: {
            width: 'auto',
        },
        icon: <img src={TOOLBAR_FONT_SETTING} />,
        text: toolbarConfig.content,
        tooltip: toolbarConfig.content,
        respectOffline: true,
    },
];
